import styled, { keyframes, css } from 'styled-components';

export const rotateGradient = keyframes`
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
`;

export const DayChip = styled.div`
    position: relative;
    padding: 7px 16px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    user-select: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: none !important;

    ${({ $isSelected }) =>
        $isSelected
            ? css`
        /* Glassy Look when Selected */
        background: linear-gradient(135deg, rgba(99, 102, 241, 0.88), rgba(139, 92, 246, 0.88));
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        color: #ffffff;
        border: 1px solid rgba(255, 255, 255, 0.4);
        box-shadow: none !important;

        &:hover {
            transform: translateY(-2px) scale(1.03);
            box-shadow: none !important;
            background: linear-gradient(135deg, rgba(99, 102, 241, 0.95), rgba(139, 92, 246, 0.95));
        }
    `
            : css`
        /* Standard Unselected Chip */
        background: var(--ant-color-fill-alter, #f8fafc);
        color: var(--ant-color-text-secondary, #64748b);
        border: 1px solid var(--ant-color-border, #e2e8f0);
        box-shadow: none !important;

        /* Gradient Border Effect ONLY ON HOVER */
        &:hover {
            transform: translateY(-2px) scale(1.03);
            color: #6366f1;
            border: 1.5px solid transparent;
            background-image: 
                linear-gradient(var(--ant-color-bg-container, #ffffff), var(--ant-color-bg-container, #ffffff)), 
                linear-gradient(90deg, #4285F4, #9333ea, #EA4335, #FBBC05, #34A853, #4285F4);
            background-origin: border-box;
            background-clip: padding-box, border-box;
            background-size: 100% 100%, 300% 300%;
            animation: ${rotateGradient} 2s ease infinite;
            box-shadow: none !important;
        }
    `}

    &:active {
        transform: translateY(0) scale(0.98);
    }
`;
